import React, { useState, useRef } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Chip from "@mui/material/Chip";
import MCard from "components/Shared/MCard.tsx";
import { DATA_TYPE_HYPERLINK } from "typeConstants/dataTypes";
import { stringFieldDefault } from "components/Utility";
import { MSpinner } from "components/Shared";
import { updateGpsData } from "requests/qualityAssurance/index.ts";
import { CASE_GEOCODE_EDIT } from "typeConstants/rights";
import WebConfig from "middlewares/WebConfig";

const GPSLocation = ({
  refresh, photos, address,
  gpsData, gpsData: { distanceFromAddress },
  controlNumber, canEdit, onAddressClick, ssoToken }) => {
  const mounted = useRef(true);
  const [primaryPhoto, setPrimaryPhoto] = useState(null);

  const getPrimaryPhotoSrc = () => {
    let gpsPhoto = photos.filter((photo) => {
      return photo.Tags.includes("GPS Location");
    });
    let locationPhoto = photos.filter((photo) => {
      return photo.Geocode.Latitude || photo.Geocode.Longitude;
    });
    let photo = null;
    if (gpsPhoto.length > 0) {
      photo = gpsPhoto[0];
    } else if (locationPhoto.length > 0) {
      photo = locationPhoto[0];
    }
    if (photo !== null && (!primaryPhoto || (primaryPhoto && (primaryPhoto.latitude !== photo.latitude || primaryPhoto.longitude !== photo.longitude)))) {
      setPrimaryPhoto(photo);
      refresh();
    }
  };

  const transformPhoto = () => {
    if (primaryPhoto !== null) {
      return {
        src: `${WebConfig.photoService}/${primaryPhoto.BucketUri}/${primaryPhoto.Id}?SSO=${ssoToken}`,
        tags: primaryPhoto.Tags,
        latitude: primaryPhoto.Geocode.Latitude,
        longitude: primaryPhoto.Geocode.Longitude,
      };
    } else {
      return {
        src: "",
        tags: [],
        latitude: null,
        longitude: null
      };
    }
  };

  const getFields = () => {
    if (photos && photos.length) {
      getPrimaryPhotoSrc(photos);
    }
    let photoToUse = transformPhoto();
    let latitude = photoToUse.latitude;
    let longitude = photoToUse.longitude;
    let fields = [{
      key: "photo",
      label: "",
      editable: false,
      control: (
        <div className="gps-photo-container">
          <img src={photoToUse.src} />
          <div className="gps-photo-tags">
            {photoToUse.tags.map((tag, idx) => {
              return <Chip key={idx} label={tag} />;
            })}
          </div>
        </div>)
    }];
    if (!latitude && !longitude) {
      fields.push({
        key: "warning",
        label: "",
        editable: false,
        control: (
          <div style={{ color: "red" }}>
            Warning: No Photo Geo-Coordinates Found
          </div>)
      });
    }
    fields.push({
      key: "latitude",
      label: "Latitude",
      value: latitude,
      editable: true,
    }, {
      key: "longitude",
      label: "Longitude",
      value: longitude,
      editable: true,
    }, {
      key: "address",
      label: "Property Address",
      value: { label: address, onClick: () => onAddressClick(`Map (GPS)`, latitude, longitude) },
      dataType: getDataType(address, "address"),
      editable: false,
    }, {
      key: "distance",
      label: "Distance from Address",
      value: distanceFromAddress,
      editable: false,
    });
    return fields;
  };

  const updateFields = (fields) => {
    let photo = { ...primaryPhoto };
    fields.forEach(s => photo[s.key] = s.value);
    updateGpsData(controlNumber, photo, () => {
      setPrimaryPhoto(null);
    }, mounted);
  };

  const getDataType = (properties, propertyName) => {
    if (properties?.includes(stringFieldDefault))
      return null;
    switch (propertyName) {
      case "address":
        return DATA_TYPE_HYPERLINK;
    }
  };

  if (gpsData.needsFetch) {
    return <MSpinner />;
  }

  return (
    <MCard
      title="GPS Location"
      fields={getFields(gpsData)}
      isEditable={!!primaryPhoto && canEdit}
      className="gps-location-card"
      onEditFinished={s => updateFields(s)}
    />
  );
};

GPSLocation.propTypes = {
  controlNumber: PropTypes.number,
  address: PropTypes.string,
  photos: PropTypes.object,
  gpsData: PropTypes.object,
  refresh: PropTypes.func,
  canEdit: PropTypes.bool,
  onAddressClick: PropTypes.func,
  ssoToken: PropTypes.string,
};

const mstp = state => ({
  canEdit: state.user.profile.rights.includes(CASE_GEOCODE_EDIT),
  ssoToken: state.user.profile.token,
});

export default connect(mstp, null)(GPSLocation);
